// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: true,
    },
    selector: {
        collectionHeader: '.page-title'
    }
};

// Declare Templates
var bcSfFilterTemplate = {
    // Grid Template
    'productGridItemHtml': '<div class="product-list-item">' +
                                '{{itemOverlay}}' +
                                '<figure class="product-list-item-thumbnail" {{itemFlipImage}}>' +
                                    '<a href="{{itemUrl}}">' +
                                        '<img class="{{itemCustomImageClass}}" src="{{itemThumbUrl}}" alt="{{itemTitle}}" />' +
                                    '</a>' +
                                    '{{itemLabels}}' +
                                '</figure>' +
                                '{{itemStartDetailWrapper}}' +
                                    '<div class="product-list-item-details">' +
                                        '<p class="product-list-item-vendor vendor meta"><a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></p>' +
                                        '<h3 class="product-list-item-title"><a href="{{itemUrl}}">{{itemTitle}}</a></h3>' +
                                        '<p class="product-list-item-price">{{itemPrice}}</p>' +
                                    '</div>' +
                                '{{itemEndDetailWrapper}}' +
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li class="pagination-previous"><a href="{{itemUrl}}" title="">' + bcSfFilterConfig.label.pagination_previous + '</a></li>',
    'previousDisabledHtml': '<li class="pagination-previous"><span>' + bcSfFilterConfig.label.pagination_previous + '</span></li>',
    'nextActiveHtml': '<li class="pagination-next"><a href="{{itemUrl}}" title="">' + bcSfFilterConfig.label.pagination_next + '</a></li>',
    'nextDisabledHtml': '<li class="pagination-next"><span>' + bcSfFilterConfig.label.pagination_next + '</span></li>',
    'pageItemHtml': '<li class="pagination-position"></li>',
    'paginateHtml': '{{previous}}{{pageItems}}{{next}}',
  
    // Sorting Template
    'sortingHtml': '<label class="selected-text">' + bcSfFilterConfig.label.sorting + '</label><strong></strong><select>{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data) {
    /*** Prepare data ***/
    var images = data.images_info;
     // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

    // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Overlay
    var itemOverlayHtml = '';
    if (bcSfFilterConfig.custom.product_text_style == 'overlay') {
        itemOverlayHtml = '<a class="product-list-item-overlay-link" href="{{itemUrl}}"></a>';
    }
    itemHtml = itemHtml.replace(/{{itemOverlay}}/g, itemOverlayHtml);

    // Get Stock text
    if (bcSfFilterConfig.custom.stock_level_overlay && !soldOut) {
        var total = 0;
        var threshold = bcSfFilterConfig.custom.stock_level_overlay_threshold * 1;
        var infinity = false;
        for (var k in data.variants) {
            var variant = data['variants'][k];
            if (variant['inventory_management'] == null) {
                infinity = true;
            } else if (variant['inventory_management'] == '') { 
                infinity = true;
            } else if (variant['inventory_management'] == 'shopify' && variant.inventory_policy == 'continue') { 
                infinity = true;
            } else if (infinity == false) {
                total += variant.inventory_quantity;
            }
        }
        var stockText = bcSfFilterConfig.label.stock_indicator_message.replace('num', total);
    }

    // Get Sale text
    var saleText = bcSfFilterConfig.label.sale;
    var percentage = Math.floor((data.compare_at_price_max - data.price_min) / data.compare_at_price_max * 100);
    saleText = bcSfFilterConfig.label.sale.replace('{PCT}', percentage);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src'], 'grande') : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    // Add Flip image
    var checkFlipImage = images.length > 1 && bcSfFilterConfig.custom.product_image_flip ? true : false;
    var itemFlipImage = '';
    if (checkFlipImage) {
        itemFlipImage = 'style="background-image:url(' + this.optimizeImage(images[1]['src'], 'grande') + ')"';
    }
    itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImage);

    // Add custom image class
    var itemCustomImageClass = checkFlipImage ? 'primary-image' : 'only-image';
    itemHtml = itemHtml.replace(/{{itemCustomImageClass}}/g, itemCustomImageClass);

    // Add Labels
    var itemLabelsHtml = '';
    if (!soldOut) {
        if (bcSfFilterConfig.custom.stock_level_overlay && infinity == false && total < threshold && onSale) {
            itemLabelsHtml += '<span class="product-list-item-badge meta sale">' + saleText + '<br>' + stockText + '</span>';
        } else if (bcSfFilterConfig.custom.stock_level_overlay && infinity == false && total < threshold) {
            itemLabelsHtml += '<span class="product-list-item-badge meta inventory">' + stockText + '</span>';
        } else if (onSale) {
            itemLabelsHtml += '<span class="product-list-item-badge meta sale">' + saleText + '</span>';
        }
    } else {
        itemLabelsHtml += '<span class="product-list-item-badge inventory">' + bcSfFilterConfig.label.sold_out + '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemLabels}}/g, itemLabelsHtml);

    // Add Price
    var itemPriceHtml = '';
    if (!soldOut) {
        if (priceVaries) {
            itemPriceHtml += '<span class="price">' + bcSfFilterConfig.label.from_price + ' <span class="money">' + this.formatMoney(data.price_min) + '</span></span>';
        } else {
            if (onSale) {
                itemPriceHtml += '<span class="price on-sale">' +
                                    '<span class="money">' + this.formatMoney(data.price_min) + '</span>' +
                                    '<span class="original money">' + this.formatMoney(data.compare_at_price_min) + '</span>' +
                                '</span>';
            } else {
                itemPriceHtml += '<span class="price money">' + this.formatMoney(data.price_min) + '</span>';
            }
        }
    } else {
        itemPriceHtml += bcSfFilterConfig.custom.sold_out;
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemVendorUrl}}/g, this.buildProductItemVendorUrl(data.vendor));

    // Add Detail wrapper
    var itemStartDetailWrapper = '', itemEndDetailWrapper = '';
    if (bcSfFilterConfig.custom.product_text_style == 'overlay') {
        itemStartDetailWrapper = '<div class="product-list-item-details-wrapper">';
        itemEndDetailWrapper = '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemStartDetailWrapper}}/g, itemStartDetailWrapper);
    itemHtml = itemHtml.replace(/{{itemEndDetailWrapper}}/g, itemEndDetailWrapper);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
        jQ(this.selector.pagination).html('');
        return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
        var paginationHtml = bcSfFilterTemplate.paginateHtml;

        // Build Previous
        var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
        previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
        paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

        // Build Next
        var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
        nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
        paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

        // Build page items
        paginationHtml = paginationHtml.replace(/{{pageItems}}/g, bcSfFilterConfig.label.pagination_summary.replace(/{{ current_page }}/g, currentPage).replace(/{{ total_pages }}/g, totalPage));

        jQ(this.selector.pagination).html(paginationHtml);
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content 
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
          
            var selectedLabel = jQ(this.selector.topSorting + ' select option[value="' + this.queryParams.sort + '"]').text();
            jQ(this.selector.topSorting + ' strong').text(selectedLabel);
        }
    }
};

// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
        var colInfo = colData.collection;
        var breadcrumbHtml = '<a href="/">' + bcSfFilterConfig.label.breadcrumb_home + '</a>';
        breadcrumbHtml += ' <span class="divider">/</span>';
        if (colInfo.handle == 'all') {
            breadcrumbHtml += ' <span>' + bcSfFilterConfig.label.all_products + '</span>';
        } else {
            breadcrumbHtml += ' <a href="/collections">' + bcSfFilterConfig.label.collection_listing_title + '</a> <span class="divider">/</span> <span>' + colInfo.title + '</span>';
        }
        jQ('.breadcrumbs').html(breadcrumbHtml);
    }
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {};

    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};